import { useRecommendedSnacks } from "@multicines/hooks";
import { BaseProduct } from "artisn/types";
import React, { useState } from "react";

import Styles from "./RecommendedSnacksList.styles";
import { RecommendedSnacksListProps as Props } from "./RecommendedSnacksList.types";
import ProductModal from "components/global/ProductModal/ProductModal";
import SnackSlider from "components/global/SnackSlider/SnackSlider";
import CONSTANTS from "config/constants";
import useI18n from "hooks/useI18n";
import { useAuthStore } from "stores/auth/auth.store";
import { useStoresStore } from "stores/stores/stores.store";
import { goToProductDetail } from "utils/seo.utils";

const { WITH_PRODUCT_MODAL } = CONSTANTS.FEATURE_FLAGS;

const RecommendedSnacksList: React.FC<Props> = props => {
  const { discounts, memberLevelId } = props;
  const isAnonymous = useAuthStore(state => state.isAnonymous);
  const uid = useAuthStore(state => state.uid);
  const auth = { isAnonymous, uid };
  const selectedStore = useStoresStore(store => store.selectedStore);
  const [, snacksStore] = selectedStore ?? [];
  const { storeId } = snacksStore ?? {};
  const recommendedSnacksHook = useRecommendedSnacks(
    auth,
    storeId!,
    discounts,
    memberLevelId
  );
  const t = useI18n();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [productId, setProductId] = useState("");

  const { eligibleProducts, status } = recommendedSnacksHook ?? {};
  const { errorTitle, errorDescription } = recommendedSnacksHook ?? {};
  const { handleRefetch } = recommendedSnacksHook ?? {};

  const onClickHandler = (product: BaseProduct) => {
    setProductId(product.productId);

    if (WITH_PRODUCT_MODAL) {
      setIsOpenModal(true);
    } else {
      goToProductDetail(product);
    }
  };

  const hasEligibleProducts = eligibleProducts?.length > 0;
  if (!hasEligibleProducts) return null;

  return (
    <>
      <Styles className="RecommendedSnacksList">
        <h2 className="RecommendedSnacksList__title">
          {t.repeatOrder.recommendedProduct}
        </h2>
        <SnackSlider
          status={status}
          errorTitle={errorTitle}
          errorDescription={errorDescription}
          onPressError={handleRefetch}
          products={eligibleProducts}
          onPressSnack={onClickHandler}
          discounts={discounts}
        />
      </Styles>
      {WITH_PRODUCT_MODAL ? (
        <ProductModal
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          productId={productId}
        />
      ) : null}
    </>
  );
};

export default RecommendedSnacksList;
